import TreeNode from '../tree/tree-node'

export default {
    components: {
        TreeNode
    },
    methods: {
        handleExpand(isExpand, data) {
            this.$emit('handleExpand', isExpand, data || this.data)
        },
        handleChecked(isChecked, data) {
            this.$emit('handleChecked', isChecked, data || this.data)
        }
    }
}
